
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class QuestionTagConstants {
	static websiteDesign: QuestionTagConstantsType = 'WebsiteDesign';
	static approveOrderSpecialConditions: QuestionTagConstantsType = 'ApproveOrderSpecialConditions';

	static values = ['WebsiteDesign', 'ApproveOrderSpecialConditions'];
}
export type QuestionTagConstantsType = 'WebsiteDesign' | 'ApproveOrderSpecialConditions';

